import { UnitType } from '@exodus/currency'

const name = 'polkadot'
const displayName = 'Polkadot'
const ticker = 'DOT'
const displayTicker = ticker
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#F461AF'
const gradientColors = ['#E6007A', '#F461AF']
const gradientCoords = { x1: '0%', y1: '21.958%', x2: '99.612%', y2: '78.958%' }
const chainBadgeColors = gradientColors

const units = {
  Planck: 0,
  DOT: 10,
}
const currency = UnitType.create(units)

const curve = 'ed25519'
const keyDerivationAlgorithm = 'SLIP10'

const assetType = 'OTHER'
const blockExplorer = {
  addressUrl: (address) => `https://polkadot.subscan.io/account/${encodeURIComponent(address)}`,
  txUrl: (txId) => `https://polkadot.subscan.io/extrinsic/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Polkadot is a next-generation blockchain protocol connecting multiple specialized blockchains into one unified network.',
  reddit: 'https://www.reddit.com/r/dot',
  twitter: 'https://twitter.com/Polkadot',
  website: 'https://polkadot.network',
  telegram: 'https://t.me/polkadotofficial',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  curve,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  keyDerivationAlgorithm,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
